import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { HttpLoggingOptions } from '../models/http-logging-options.model';
import { ErrorReportingService } from '../services/error-reporting.service';
import { HttpContextTokens } from '../constants';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor(private errorReporting: ErrorReportingService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //get additional settings from request.context
    //options will always have a value, the default is set in constructor of HttpLoggingOptions
    var options: HttpLoggingOptions = request.context.get(HttpContextTokens.options);

    //If the "doNotLog" option is set, then just move on to next
    if (options.doNotLog === true) {
      return next.handle(request);
    } else {
      //Log url and payload (if applicable) as debug
      this.errorReporting.logDebug(`[${request.method}] ${request.urlWithParams}`);
      if (request.method !== 'GET') {
        this.errorReporting.logDebug(JSON.stringify(request.body) ?? '[NO BODY]');
      }
      return next.handle(request).pipe(
        map((response) => {
          if (response instanceof HttpResponse) {
            if (response.ok) {
              //Show Success in "Snackbar"
              if (options.getDisplaySuccess(request.method)) {
                this.errorReporting.displayInfo(options.successText);
              }
            } else {
              //Log non 200 / success reponses as error
              this.errorReporting.logError(
                `[${request.method}] ${request.urlWithParams} RETURNED ${response.statusText} (${response.status}) : ${response.body}`,
                options.errorText,
                options.source
              );
            }
          }
          return response;
        })
      );
    }
  }
}
